import React from 'react';

import { Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
  root: {
    alignItems: 'center',
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    gap: theme.spacing(1),
    height: '100%',
    justifyContent: 'center',
    padding: theme.spacing(3),
  },
}));

/** Stands in for any page other than a task or a document in an external session. */
export function NotPermittedPage(): JSX.Element {
  const { classes } = useStyles();

  return (
    <div className={classes.root}>
      <Typography align="center" variant="body1">
        You are not permitted to access this section of the app.
      </Typography>
      <Typography align="center" color="text.secondary" variant="body2">
        Open the link in your email to get back to your task.
      </Typography>
    </div>
  );
}
